import React from 'react';
import { Flex } from '../../../../../../ui';
import { getFormattedPrice } from '../../../../../shared/i18n/price/utils/getFormattedPrice';
import { IExtraVariant } from '../../../../domain/ancillary/domain/models/IExtraVariant';

interface IExtraVariantSummaryProps {
	variant: IExtraVariant;
}

export const ExtraVariantSummary = ({ variant }: IExtraVariantSummaryProps) => (
	<Flex justifyContent="space-between">
		<span>{variant.name}</span>
		<span>{getFormattedPrice(variant.price)}</span>
	</Flex>
);
